import RestService from "./rest.service";

class evaluation360Service {

  listCycle() {
    return new Promise((fnResolve, fnReject) => {
      let url = `app/kpi/evaluate/dropdown/cycle?type=360`
      RestService.getListCycle(url).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getList(limit, page, form_status, order_by, sort, search, cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/evaluate/360/manage/manager?limit=${limit}&page=${page}${`&form_status=${form_status}`}${order_by !== "" ? `&order_by=${order_by}` : ""}${sort !== "" ? `&sort=${sort}` : ""}${search !== "" ? `&search=${search}` : ""}${cycle_id !== "" ? `&cycle_id=${cycle_id}` : ""}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getListEmployee(limit, page, form_status, order_by, sort) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/evaluate/360/manage/employee?limit=${limit}&page=${page}${`&form_status=${form_status}`}${order_by !== "" ? `&order_by=${order_by}` : ""}${sort !== "" ? `&sort=${sort}` : ""}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getListSearchEmployee(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/evaluate/360/search/employee`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  addEvaluator(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/evaluate/360/manage`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  adminAddEvaluator(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/evaluate/360/manage`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

}

export default new evaluation360Service();
